export default {
    props: {
        isLoading: Boolean,
        color: {
            type: String,
            default: "primary",
        },
        name: String,
    },
    template: `
    <button type="button"
        :class="{ 
            'custom-button-primary': color === 'primary',
            'custom-button-secondary': color === 'secondary', 
            'custom-button-loading': isLoading,
        }"
        class="custom-button">
        <span v-if="!isLoading">{{ name }}</span>
        <span v-if="isLoading"><i class="fa fa-cog fa-spin"></i> Sending...</span>
    </button>
    `
}